import FormDiagnostico from "./FormDiagnostico";
import FormPaciente from "./FormPaciente";
import HistorialClinico from "./HistorialClinico";
import MeditocTab from "../../../utils/MeditocTab";
import MeditocTabs from "../../../utils/MeditocTabs";
import { useState } from "react";

export default function Consulta() {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <MeditocTabs
            tabs={["PACIENTE", "DIAGNÓSTICO Y TRATAMIENTO", "HISTORIAL"]}
            index={tabIndex}
            setIndex={setTabIndex}
        >
            <MeditocTab id={0} index={tabIndex}>
                <FormPaciente />
            </MeditocTab>
            <MeditocTab id={1} index={tabIndex}>
                <FormDiagnostico />
            </MeditocTab>
            <MeditocTab id={2} index={tabIndex}>
                <HistorialClinico />
            </MeditocTab>
        </MeditocTabs>
    );
}
